/**
 * @generated SignedSource<<f07be327420e8df3fbaa714b35e8cda5>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "StartSurveyResponsePayload",
            "kind": "LinkedField",
            "name": "surveyResponder_startSurveyResponse",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfSurveyResponse",
                    "kind": "LinkedField",
                    "name": "responseEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "SurveyResponse",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SurveyResponsePage_startSurveyResponseMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SurveyResponsePage_startSurveyResponseMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "56ffcb7044075de2205251f080ea60df",
            "id": null,
            "metadata": {},
            "name": "SurveyResponsePage_startSurveyResponseMutation",
            "operationKind": "mutation",
            "text": "mutation SurveyResponsePage_startSurveyResponseMutation(\n  $model: StartSurveyResponseRequestInput!\n) {\n  surveyResponder_startSurveyResponse(model: $model) {\n    responseEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "c756f83b4fbfd6e18d3d1c774bab5c01";
export default node;
